import * as CONSTANTS from './constants';

const initialState = {
  // Define any default states needed, if not already done.
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    // Existing cases...

    case CONSTANTS.ABOUT_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.ABOUT_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.ABOUT_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.TERM_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.TERM_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.TERM_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.LEGAL_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.LEGAL_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.LEGAL_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.NOTIFICATION_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.NOTIFICATION_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.NOTIFICATION_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.HELP_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.HELP_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.HELP_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.PARTNER_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.PARTNER_POST:
      return {
        data: action.payload.data,
      };
    case CONSTANTS.PARTNER_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.PARTNER_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.CURRENCY_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.CURRENCY_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.CURRENCY_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.USER_GET_ALL:
      return {
        ...state,
      };
    case CONSTANTS.USER_UPDATE:
      return {
        userInfo: action.payload,
      };
    case CONSTANTS.USER_FAILLED: {
      return { ...state, access_token: null };
    }

    case CONSTANTS.USER_PROFILEUPDATE: {
      return {
        ...state,
        userInfo: action.payload.data,
      };
    }

    case CONSTANTS.PASSWORD_UPDATE: {
      return {
        ...state,
        isUpdated: action.payload,
      };
    }
    case CONSTANTS.PASSWORD_FAILED: {
      return { ...state, access_token: null };
    }

    // New cases for approving and rejecting users
    case CONSTANTS.APPROVE_USER_SUCCESS: {
      return {
        ...state,
        userInfo: { ...state.userInfo, isApproved: true }, // Assuming userInfo structure has isApproved
      };
    }
    case CONSTANTS.APPROVE_USER_FAILURE: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case CONSTANTS.REJECT_USER_SUCCESS: {
      return {
        ...state,
        userInfo: { ...state.userInfo, isApproved: false }, // Assuming userInfo structure has isApproved
      };
    }
    case CONSTANTS.REJECT_USER_FAILURE: {
      return {
        ...state,
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export default adminReducer;
